import { Link, Navigate, useParams } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import PageMeta from '../components/PageMeta';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';
import { getBlogPost, getRelatedPosts } from '../content/blogPosts';

const SITE_URL = 'https://agence.finance';

export default function BlogPost() {
  const { slug } = useParams();
  const { isAuthenticated } = useAuth();
  const post = getBlogPost(slug);

  if (!post) return <Navigate to="/blog/" replace />;

  const related = getRelatedPosts(post);
  const path = `/blog/${post.slug}/`;

  const schema = {
    '@context': 'https://schema.org',
    // BlogPosting, not the generic Article: these are blog posts, and Google accepts the
    // subtype for article rich results (TODO Unversioned §3, SEO P1).
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.description,
    url: `${SITE_URL}${path}`,
    mainEntityOfPage: { '@type': 'WebPage', '@id': `${SITE_URL}${path}` },
    image: `${SITE_URL}/og-banner.png`,
    datePublished: post.publishedDate,
    dateModified: post.publishedDate,
    author: { '@type': 'Organization', name: 'Agence', url: SITE_URL },
    publisher: {
      '@type': 'Organization',
      name: 'Agence',
      url: SITE_URL,
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/agence-icon-circle.png` },
    },
  };

  return (
    <div className="page">
      <PageMeta
        title={post.title}
        titleOverride={`${post.title} | Agence`}
        description={post.ogDescription}
        path={path}
        type="article"
        publishedTime={post.publishedDate}
        modifiedTime={post.publishedDate}
        schema={schema}
      />
      <PublicNav />
      <main>
        <article className="blog-wrap" itemScope itemType="https://schema.org/BlogPosting">
          <nav className="blog-crumb" aria-label="Breadcrumb">
            <Link to="/">Agence</Link><span>›</span>
            <Link to="/blog/">Blog</Link><span>›</span>
            <span aria-current="page">{post.breadcrumbLabel}</span>
          </nav>

          <span className="blog-label">{post.tag}</span>
          <h1 className="blog-post-h1" itemProp="headline">{post.title}</h1>
          <p className="blog-meta">
            By <Link to="/">Agence</Link> &nbsp;·&nbsp; {post.displayDate} &nbsp;·&nbsp; {post.readTime}
          </p>

          <div className="blog-body" itemProp="articleBody" dangerouslySetInnerHTML={{ __html: post.bodyHtml }} />

          {related.length > 0 && (
            <div className="blog-related">
              <h2>Related Reading</h2>
              <ul>
                {related.map(r => (
                  <li key={r.slug}><Link to={`/blog/${r.slug}`}>{r.title}</Link></li>
                ))}
              </ul>
            </div>
          )}

          <div className="blog-cta">
            <h2>{post.ctaHeadline}</h2>
            {isAuthenticated ? (
              <>
                <p>You're already signed in — jump back into your dashboard.</p>
                <Link to="/" className="blog-cta-btn">Open Agence</Link>
              </>
            ) : (
              <>
                <p>Connect your bank and brokerage. Free to start — no card required.</p>
                <Link to="/register" className="blog-cta-btn">Get started free</Link>
              </>
            )}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
